import { environment } from './../../environments/environment';

const UUID: (a?: any) => any = function(a: any){
    return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : (1e7 + '' + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, UUID as any);
  };

export class GlobalConstants {
    public static apiBaseURL: string = environment.apiBaseURL;
    public static apiURL: string = environment.apiBaseURL + '/survey';

    public static publicKey: string = `-----BEGIN RSA PUBLIC KEY-----
    MIIBCgKCAQEAwKVOit6zj4DNUvuKFSGzmN4RmWllBTmVUlaErzO3cKoIFAnR4eqT
    m3kBJL1Bvc6oXI//e+cmSdwKDwn5Ol8xLadLmNcLJQUJtHQyOZBT6SOj31XGAwmm
    tGysTRqXe7FsPqp0RMC/92Q2bWpfJXbMsRoCJ0A4FpFCJiXOWY3Fx0We+KYuyhpJ
    wp2w8CrD9IEGI0ch9DbRti5VrYlqtvo3JqFhifMUgWsx25xgnUCus6MO7fiMLvWx
    CRWVelTzlUrX7ynwQABmbBVLSa1PZm7J+1KzDBrj4fZobkGpCtlakbD3AucDtTR5
    AIBRwcmpWNvCI8cxKIFkWf2L8aGo/9Q5NwIDAQAB
    -----END RSA PUBLIC KEY-----
    `;

    public static UUID: (a?: any | undefined) => any = UUID;
}